module.exports = __webpack_public_path__ + "assets/img/arrow-select.6ce16204.svg";